{
    "TITLE" : "Application à Distance",
    
        "SHARED": {
            "INTERNET_OFFLINE": "Votre connexion Internet semble être hors ligne.",
            "LANGUAGE": "La Langue",
            "NO_FEATURE": "Votre licence ne contient pas cette fonctionnalité. Veuillez contacter votre administrateur.",
            "FEATURE_UNAVAILABLE": "Votre licence ne contient pas cette fonctionnalité.",
            "APP_UPDATE_NEEDED": "To use this feature, this participant needs to update their app.",
            "TRAINING_DISABLED": "Vous n'êtes pas autorisé à utiliser cette fonctionnalité. Veuillez demander la permission à l'hôte."
        },
        "UPDATE_MODAL": {
            "TITLE": "Mise à jour disponible",
            "MESSAGE": "Nouvelle version disponible. Cette page sera rechargée après la mise à jour.",
            "UPDATE": "Recharger",
            "UPDATE_FAILED": "Mise à jour a échoué"
        },
        "LOGIN" : {
        "SSO-BUTTON": "Se connecter avec SSO",
            "APP_NAME": "{{ appName }} Remote",
            "TITLE": "Connexion à l'application distante",
            "ACCOUNT_PLACEHOLDER" : "Nom du compte",
            "ACCOUNT_REQUIRED" : "Le nom du compte est requis.",
            "ACCOUNT_SHORT" : "Le nom du compte doit comporter au moins 2 caractères.",
            "USERNAME_PLACEHOLDER" : "Nom d'utilisateur",
            "USERNAME_REQUIRED" : "Le nom d'utilisateur est requis.",
            "USERNAME_SHORT" : "Le nom d'utilisateur doit comporter au moins 2 caractères.",
            "PASSWORD_PLACEHOLDER" : "Mot de passe",
            "PASSWORD_REQUIRED" : "Mot de passe requis.",
            "PASSWORD_SHORT" : "Le mot de passe doit être au moins de 6 caractères.",
            "REMEMBER_ACCOUNT_NAME": "N'oubliez pas le nom du compte",
            "VERIFICATION_CODE": "Code de vérification",
            "TWO_FACTOR_EMAIL_SENDED": "Nous vous avons envoyé un e-mail avec un code de vérification.",
            "VERIFY_BUTTON": "VÉRIFIER",
            "LOGIN_BUTTON" : "S'IDENTIFIER",
            "BACK_BUTTON" : "RETOUR",
            "BEFORE_TERMS": "En cliquant sur rejoindre, vous acceptez nos ",
            "TERMS": "Conditions d'utilisation",
            "CONJUNCTION": " et ",
            "PRIVACY": "Politique de confidentialité",
            "AFTER_PRIVACY": ".",
            "GUEST_DELETED": "Vous êtes déconnecté.",
            "USER_DELETED": "Votre compte a été supprimé. Veuillez contacter votre administrateur.",
            "USER_DISABLED": "Votre compte a été désactivé. Veuillez contacter votre administrateur.",
            "LOGGED_IN_ANOTHER_SESSION": "Vous êtes connecté dans une autre session.",
            "LOGGED_OUT_UNKNOWN": "Quelque chose a mal tourné.",
            "NO_INTERNET_ERROR": "Pas d'Internet. S'il vous plait, vérifiez votre connexion internet.",
            "USERNAME_PASSWORD_ERROR" : "Le nom du compte, le nom d'utilisateur ou le mot de passe sont incorrects.",
            "ACCOUNT_DISABLED": "Votre compte à expiré. Veuillez contacter {{ contactMail }}",
            "INVALID_VERIFICATION_CODE" : "Code de vérification en deux étapes non valide.",
            "UNKNOWN_ERROR" : "Une erreur s'est produite lors de la connexion.",
            "SIMULTANE_LOGIN_ERROR": "Vous êtes connecté à une autre session.",
            "USE_CHINA_SERVERS": "Je me connecte depuis la Chine",
            "CHINA_SERVERS_CAUTION": "Cette option peut entraîner une latence en dehors de la Chine continentale.",
            "MULTI_LOGIN_MODAL": {
                "TITLE": "Connexion Multiple",
                "MESSAGE": "Votre utilisateur s&#39;est déjà connecté sur un autre appareil. Si vous continuez, l&#39;autre utilisateur sera déconnecté.",
                "CANCEL": "Annuler",
                "PROCEED": "Procéder"
            }
        },
        "MAIN" : {
            "LICENSE_LEFT": "Il vous reste {{ days }} jours dans votre licence {{ appName }} Remote.",
            "DEMO_LEFT": "Il vous reste {{ days }} jours dans votre essai {{ appName }} Remote.",
            "LEFT_BAR": {
                "LOBBY": "Lobby",
                "ROOMS": "Pièces",
                "MEETINGS": "Réunions",
                "FEEDBACK": "Retour",
                "CONTACTS": "Utilisateurs",
                "SESSIONS": "Séances",
                "TICKETS": "Tickets",
                "PRECALL_TEST": "Test Precall",
                "WHATS_NEW": "Quoi de neuf",
                "PROFILE": "Profil",
                "HELP_CENTER": "Centre d'aide",
                "LOGOUT": "Connectez - Out"
            },
            "CALL_MESSAGE": {
                "TITLE":"Appel entrant de <strong>{{ caller_name }}</strong>",
                "DENY": "Nier",
                "ACCEPT": "J'accepte"
            },
            "GET_EXPORT_MODAL": {
                "TITLE": "Obtenir L'exportation de Session",
                "MESSAGE1": "Veuillez entrer votre adresse e-mail pour recevoir le lien de téléchargement d'exportation de session après la fin de la session.",
                "MESSAGE2": "L'exportation de session comprendra tous les <strong>messages de discussion</strong>, <strong>instantanés</strong>, <strong>enregistrements d'appels vidéo</strong> et <strong>fichiers</strong> partagés dans la session.",
                "EXPORT_NAME_NOT_LOCKED": "Vous pouvez renommer le fichier d'exportation en entrant un nom de fichier personnalisé à la place.",
                "EXPORT_NAME_LOCKED": "Vous pourrez renommer le fichier d'exportation dès que l'autre utilisateur aura terminé l'exportation.",
                "EXPORT_NAME_RENAMED": "Le fichier d'exportation est renommé par cet utilisateur :",
                "EXPORT_NAME_PLACEHOLDER": "Nom d'exportation",
                "NOTE": "Remarque : Vous pouvez mettre à jour votre adresse e-mail à partir du menu du profil.",
                "NOTE2": "Remarque: vous pouvez mettre à jour votre adresse e-mail via votre administrateur.",
                "OPEN_PROFILE": "Ouvrir le profil",
                "EMAIL": "Email",
                "EMAIL_REQUIRED": "Email requis.",
                "EMAIL_INVALID": "Format d'email invalide.",
                "CLOSE": "Fermer",
                "SEND": "Envoyer",
                "EXPORT_SUCCEEDED": "L'exportation de session sera envoyée après la fin de la session.",
                "ENDED_SESSION_EXPORT_SUCCEEDED": "L'exportation de session est envoyée.",
                "EXPORT_FAILED": "Une erreur est survenue."
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "Gérer l'accès public",
                "MANAGE-PUBLIC-ACCESS-TEXT": "Vous pouvez arrêter de partager ce flux de travail en supprimant l'accès public.",
                "GENEATE-ACCESS-TEXT": "Vous pouvez générer un lien public et un code QR pour créer un accès facile pour ce flux de travail.",
                "ENABLE-PASSWORD": "Activer le mot de passe",
                "GENERATE-ACCESS": "Générer",
                "LINK": "Lien",
                "COPY": "Copier",
                "QR-CODE": "Code QR",
                "DOWNLOAD": "Télécharger",
                "SECURITY": "Sécurité",
                "PASSWORD-PROTECTED": "Protégé par mot de passe",
                "PUBLIC": "Public",
                "DELETE-ACCESS": "Supprimer l'accès public",
                "EASY-ACCESS-TITLE": "{{ shortName }} Accès facile au flux de travail",
                "OPEN-WORKFLOW-NAME": "Vous êtes sur le point d'ouvrir",
                "GUEST-EMAIL": "Email invité",
                "REQUIRED": "Ce champ est obligatoire",
                "GUEST-PASSWORD": "Mot de passe pour les invités",
                "OPEN": "OUVRIR",
                "OPEN-APP": "Nous suggérons d'ouvrir ce flux de travail dans notre application pour une meilleure expérience.",
                "COPY-LINK-TEXT": "Copiez le lien dans le presse-papiers pour ouvrir ce flux de travail lorsque l'application est lancée.",
                "DOWNLOAD-APP": "TÉLÉCHARGER L'APPLICATION",
                "DOWNLOAD-SMARTGLASSES-APP": "TÉLÉCHARGER L'APPLICATION POUR LES LUNETTES INTELLIGENTES",
                "OR": "OU",
                "CONTINUE-WITH-BROWSER": "Continuer avec le navigateur",
                "PASSWORD-PROTECTED-TEXT": "Lorsque le mot de passe est activé, les utilisateurs qui ont le lien public ou le code QR ne peuvent accéder à ce flux de travail qu'en entrant le mot de passe.",
                "CREATE-PASSWORD": "Créer un mot de passe",
                "ENTER-EMAIL": "Entrez votre email",
                "ENTER-WORKFLOW-PASSWORD": "Entrez le mot de passe du flux de travail",
                "DELETE-QR-TEXT": "Pour changer le type de sécurité de l'accès facile, vous devez supprimer l'accès facile et le régénérer.",
                "LOADING-WORKFLOW": "Chargement du flux de travail...",
                "UNABLE-TO-LOAD": "Impossible de charger le flux de travail",
                "RETRY": "Réessayer",
                "GUEST-ACCESS": {
                    "TOKEN-MISSING": "Token manquant ou invalide",
                    "ID-MISSING": "L'ID du flux de travail ou l'URL de base est manquante",
                    "WORKFLOW-NOT-PUBLISHED": "Le flux de travail n'est pas publié",
                    "PUBLIC-ACCESS": "L'accès public existe déjà",
                    "NO-PUBLIC-ACCESS": "Pas d'accès public"
                },
                "QR-INFORMATION": "Informations QR"
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Flux vidéo",
                "CREATE-VIDEO-FLOW": "Créer un flux vidéo",
                "CREATED-BY-AI": "Créé par IA",
                "VERSION": "Version",
                "NO-VIDEO-FLOWS-FOUND": "Aucun flux vidéo trouvé",
                "CLEAR-ALL": "Tout effacer",
                "CONFIRM-VIDEO": "Confirmer la vidéo",
                "CONFIRM-VIDEO-TITLE": "Confirmer la conversion vidéo",
                "CONFIRM-VIDEO-MESSAGE": "Êtes-vous sûr de vouloir convertir ce flux vidéo en flux de travail? Après confirmation, vous ne pourrez plus modifier la vidéo.",
                "CONFIRM-VIDEO-BUTTON": "Confirmer et convertir",
                "MAKE-WORKFLOW-SUCCESSFUL": "Converti en flux de travail avec succès",
                "MAKE-WORKFLOW-ERROR": "Échec de la conversion en flux de travail",
                "UPLOAD-VIDEO-DESCRIPTION": "Téléchargez votre vidéo pour générer automatiquement un guide de flux de travail étape par étape.",
                "VIDEO-DURATION-LIMIT": "La durée de la vidéo ne peut pas dépasser 30 minutes.",
                "VIDEO-UPLOADED-SUCCESS": "Vidéo téléchargée avec succès !",
                "SELECT-VIDEO": "Sélectionner la vidéo",
                "CHANGE-VIDEO": "Changer la vidéo",
                "CREATE-BUTTON": "Créer",
                "AI-PROCESSING": "Traitement IA en cours",
                "SPLITTING-VIDEO": "Division de la vidéo en segments",
                "TRANSCRIBING-VIDEO": "Transcription du contenu vidéo",
                "PROCESS-WARNING": "Ce processus peut prendre jusqu'à 10 minutes. Veuillez ne pas fermer cette fenêtre."
            },
            "NAVBAR" : {
                "PRECALL_TEST": "Test Precall",
                "PRECALL_END_SESSION": "Veuillez terminer la session avant le test Precall.",
                "LOGOUT" : "Connectez - Out",
                "LANGUAGE" : "La langue",
                "LOGOUT_MODAL_TITLE": "Connectez - Out?",
                "LOGOUT_MODAL_MESSAGE": "Cela vous déconnectera.",
                "CAUTION": "Attention : cela vous déconnectera sans mettre fin à la session. Les fenêtres contextuelles et autres informations après la session peuvent être perdues (par exemple, l'exportation de la session) !",
                "LOGOUT_MODAL_MESSAGE_IN_ROOM": "Vous quitterez la session et vous déconnecterez.",
                "LOGOUT_MODAL_NO": "Annuler",
                "LOGOUT_MODAL_YES": "Connectez - Out",
                "LOGOUT_FAILED": "Une erreur s'est produite lors de la déconnexion.",
                "HELP_CENTER": "Centre d'aide",
                "PROFILE_TITLE": "Profil",
                "PROFILE_NAME": "Prénom",
                "PROFILE_EMAIL": "Email",
                "PROFILE_PASSWORD": "Mot de passe",
                "PROFILE_CHANGE_LINK": "Changement",
                "PROFILE_ADD_LINK": "Ajouter",
                "PROFILE_CLOSE": "Fermer",
                "CHANGE_PASS_TITLE": "Changer le mot de passe",
                "CHANGE_PASS_OLD_PASS": "Ancien mot de passe",
                "CHANGE_PASS_NEW_PASS": "Nouveau mot de passe",
                "CHANGE_PASS_RPT_PASS": "Confirmez le mot de passe",
                "CHANGE_PASS_REQUIRED": "Mot de passe requis.",
                "CHANGE_PASS_NOT_MATCH": "Les mots de passe ne correspondent pas.",
                "CHANGE_PASS_CLOSE_BTN": "Fermer",
                "CHANGE_PASS_CHANGE_BTN": "Changer le mot de passe",
                "CHANGE_PASS_SUCCESS": "Votre mot de passe a changé.",
                "CHANGE_PASS_WRONG": "Votre mot de passe est faux.",
                "CHANGE_PASS_FAILED": "Le changement de mot de passe a échoué.",
                "CHANGE_EMAIL_TITLE": "Changer l'e-mail",
                "CHANGE_EMAIL_NEW_EMAIL": "Nouveau courriel",
                "CHANGE_EMAIL_RPT_EMAIL": "Confirmez votre email",
                "CHANGE_EMAIL_REQUIRED": "L'e-mail est requis.",
                "CHANGE_EMAIL_NOT_VALID": "L'email n'est pas valide.",
                "CHANGE_EMAIL_NOT_MATCH": "Les adresses e-mail ne correspondent pas",
                "CHANGE_EMAIL_CLOSE_BTN": "Fermer",
                "CHANGE_EMAIL_CHANGE_BTN": "Changer l'e-mail",
                "CHANGE_EMAIL_SUCCESS": "Votre email a changé.",
                "CHANGE_EMAIL_FAILED": "Échec de la modification de l'e-mail.",
                "FEEDBACK": "Feedback",
                "SUCCESS_MESSAGE": "Merci d'avoir soumis le formulaire. Notre équipe vous répondra sous peu.",
                "CLOSE": "Fermer",
                "CREATE_NEW_PASS": "Exigences de mot de passe",
                "UPPERCASE": "Majuscule",
                "LOWERCASE": "Minuscule",
                "NUMBER": "Nombre",
                "SPECIAL": "Spéciale",
                "AT_LEAST_PASSWORD_LENGTH": "Au moins {{ passwordlength }} caractères",
                "OLD_PASSWORD": "Ancien mot de passe",
                "NOT_WHITESPACE": "Votre mot de passe ne doit pas contenir d'espaces",
                "DO_NOT_CREATE_SIMPLE": "Ne créez pas de mots de passe faibles comme '123456'",
                "STATUS": {
                    "AVAILABLE": "Disponible",
                    "BUSY": "Occupée",
                    "APPEAR_OFFLINE": "Apparaitre hors-ligne"
                }
            },
            "LOBBY" : {
                "LOBBY_SHARED": {
                    "ONGOING_CALLS_TITLE": "Appels en Cours",
                    "ROOMS_TITLE": "Vos chambres",
                    "UPCOMING_MEETINGS_TITLE" : "Réunions à venir",
                    "PREVIOUS_MEETINGS_TITLE" : "Réunions précédentes",
                    "SCHEDULE_MEETING": "Planifier une réunion",
                    "INSTANT_GUEST_ACCESS": "Accès invité instantané",
                    "INSTANT_GUEST_ACCESS_NO_CALLING": "Vous n’avez pas l’autorisation de passer des appels. Veuillez contacter votre administrateur.",
                    "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "Vous n’avez pas l’autorisation de créer un lien d’accès invité. Veuillez contacter votre administrateur.",
                    "INSTANT_GUEST_ACCESS_NO_PERM": "Vous n’avez pas l’autorisation de passer des appels ni de créer un lien d’accès invité. Veuillez contacter votre administrateur.",
                    "LINK_UNAVAILABLE": "Lien indisponible",
                    "JOIN" : "JOINDRE",
                    "CANCEL": "ANNULER",
                    "REMOVE": "SUPPRIMER",
                    "NO_ROOM": "Tu n'as pas de chambre.",
                    "NO_MEETING": "Vous n'avez aucune réunion.",
                    "NO_PREV_MEETING": "Vous n'avez aucune réunion.",
                    "NO_OTHER_USERS": "Pas d'autres utilisateurs.",
                    "SHOW_MORE": "montrer {{ count }} plus",
                    "SHOW_LESS": "Montrer moins"
                },
                "SCHEDULE_MEETING_MODAL": {
                    "TITLE": "Planifier une réunion",
                    "MEETING_TITLE": "Titre*",
                    "MEETING_TITLE_REQUIRED": "Titre requis.",
                    "START_DATE": "Démarrer",
                    "END_DATE": "Finir",
                    "CLOSE": "Fermer",
                    "SCHEDULE_SEND": "Planifier et Envoyer",
                    "SCHEDULE": "Calendrier",
                    "CANNOT_SCHEDULE": "Une erreur s'est produite lors de la planification de la réunion.",
                    "CANNOT_CANCEL_MEETING": "Une erreur s'est produite lors de l'annulation de la réunion.",
                    "ENTER_USERS": "Saisir les utilisateurs",
                    "SEND_INVITATIONS": "Envoyer des invitations",
                    "INVITATION_EMAIL_LANG": "Langue de l'e-mail d'invitation",
                    "SHARE_AFTER": "Le lien de la réunion peut également être partagé après la planification."
                },
                "CANCEL_MEETING_MODAL": {
                    "CANCEL_TITLE": "Annuler la réunion",
                    "REMOVE_TITLE": "Supprimer la réunion",
                    "CANCEL_MESSAGE": "Êtes-vous sûr de vouloir annuler la réunion ?",
                    "REMOVE_MESSAGE": "Voulez-vous vraiment supprimer la réunion ?",
                    "CLOSE": "Fermer",
                    "PROCEED": "Procéder"
                },
                "CONTACTS": {
                    "TITLE": "Utilisateurs",
                    "NO_CONTACT": "La liste des utilisateurs est vide.",
                    "NO_PERMISSION": "Vous n'êtes pas autorisé à voir la liste des utilisateurs et à appeler.",
                    "SELECT_MULTI": "Sélectionnez Plusieurs",
                    "CALL": "Appel",
                    "ADMIN": "Admin",
                    "COADMIN": "Co-Admin",
                    "EXPERT": "Expert",
                    "SUBSCRIBER": "Subscriber",
                    "USER": "User",
                    "NAME": "Nom",
                    "USERNAME": "Nom d'utilisateur",
                    "ROLE": "Rôle",
                    "NO_EXPERT": "Veuillez sélectionner au moins un expert pour passer un appel.",
                    "NAME_USERNAME": "Nom ou nom d'utilisateur",
                    "ALL_ROLES": "Tous les rôles"
                },
                "SESSIONS": {
                    "TITLE": "Séances",
                    "DATE": "Créé le",
                    "DURATION": "Durée",
                    "ROOM_NAME": "Chambre",
                    "NO_SESSIONS": "La liste des sessions est vide.",
                    "PARTICIPANTS": "Participants",
                    "EXPORT": "L'exportation",
                    "STATUS": "Statut",
                    "ON_GOING": "En cours",
                    "ENDED": "Terminé",
                    "FILES": "Des dossiers",
                    "CHAT": "Discuter",
                    "SESSION_FILES": {
                        "MULTIPLE_SELECTION": "Sélectionnez Plusieurs",
                        "DOWNLOAD": "Télécharger",
                        "DOWNLOAD_STARTED_SOON": "Le téléchargement sera bientôt commencé.",
                        "DOWNLOAD_FAILED": "Échec du téléchargement.",
                        "NO_FILE_IS_ADDED": "Aucun fichier n'est ajouté ou collaboré dans cette session.",
                        "SUCCESS_MESSAGE": "Les fichiers ont été téléchargés avec succès."
                    },
                    "ATTACHED_TICKET": "Billet joint",
                    "SESSION_DETAILS": "Détails de la session",
                    "BACK": "Arrière",
                    "GET_SESSION_EXPORT": "Obtenir l'exportation de session",
                    "ATTACH_TO_TICKET": "Joindre au billet"
                },
                "TICKETS": {
                    "TITLE": "Billets",
                    "NEW_TICKET": "Nouveau billet",
                    "ALL_ROOMS": "Toutes les chambres",
                    "ALL_STATUSES": "Tous les statuts",
                    "NO_TICKETS": "La liste des tickets est vide.",
                    "TICKET_TITLE": "Titre",
                    "ROOM": "Chambre",
                    "CREATED_BY": "Créé par",
                    "CREATED_ON": "Créé le",
                    "STATUS": "Statut",
                    "STATUS_OPEN": "ouvrir",
                    "STATUS_IN_PROGRESS": "en cours",
                    "STATUS_CLOSED": "fermé",
                    "CLOSE_PICK_TICKET": "FERMER",
                    "CREATE_NEW": "CRÉER NOUVEAU",
                    "ATTACH": "ATTACHER",
                    "CREATE_TICKET": "Créer un ticket",
                    "TICKET_DETAILS": "Détails du billet",
                    "EDIT": "MODIFIER",
                    "TICKET_TYPE": "Type de billet",
                    "ROOM2": "Pièce: ",
                    "CREATED_BY2": "Créé par: ",
                    "CREATED_ON2": "Créé le: ",
                    "ROOM3": "Chambre",
                    "STATUS2": "Statut",
                    "PRIORITY" : "Prioritaire",
                    "ASSIGNEE" : "Destinataire",
                    "FOLLOW_UP": "Date de suivi",
                    "TICKET_TITLE2": "Titre",
                    "TITLE_REQUIRED": "Titre requis",
                    "DESCRIPTION": "Description",
                    "DESCRIPTION_REQUIRED": "Description requise",
                    "RESOLUTION": "Résolution",
                    "ATTACHED_SESSIONS": "SESSIONS JOINTES",
                    "NO_ATTACHED_SESSIONS": "La liste des sessions jointes est vide",
                    "SESSION_COUNT": "Nombre de sessions: ",
                    "TOTAL_DURATION": "Durée totale: ",
                    "PARTICIPANTS2": "Participants:",
                    "COUNT_SESSIONS": " {{count}} sessions",
                    "DATE": "Date",
                    "ROOM_NAME": "Nom de la salle",
                    "PARTICIPANTS": "Participants",
                    "DURATION": "Durée",
                    "GUEST": "(Invité)",
                    "CANCEL": "ANNULER",
                    "CLOSE": "FERMER",
                    "SAVE": "ENREGISTRER",
                    "CREATE": "CRÉER",
                    "CREATED_BETWEEN": "Créé entre",
                    "ALL_CREATORS": "Tous les créateurs",
                    "SEND_VIA_EMAIL": "ENVOYER PAR EMAIL",
                    "DELETE_TICKET": "SUPPRIMER LE TICKET",
                    "DELETE_TICKET_MODAL": {
                        "TITLE" : "Supprimer le ticket ?",
                        "MESSAGE":"Voulez-vous vraiment supprimer le ticket <strong>{{title}}</strong>",
                        "CANCEL": "ANNULER",
                        "DELETE": "SUPPRIMER"
                    },
                    "LOW": "Bas",
                    "MEDIUM": "Moyen",
                    "HIGH": "Haute",
                    "CHOOSE_TICKET": "Choisir un billet",
                    "ERRORS": {
                        "TICKET_ALREADY_ATTACHED": "Billet déjà joint.",
                        "ERROR_OCCURED": "Une erreur s'est produite.",
                        "PERMISSION_DENIED": "Permission refusée.",
                        "MISSING_PARAMETERS": "Il manque des paramètres",
                        "FILE_ALREADY_EXIST": "Le fichier existe déjà"
                    },
                    "FILES": "Des dossiers",
                    "UPLOAD_FILE": "TÉLÉVERSER UN FICHIER"
                },
                "ARCHIVES": {
                    "ARCHIVE_LIST": {
                        "LOADING": "Chargement",
                        "CREATED_AT": "Créé à",
                        "SIZE": "Taille",
                        "STATUS": "Statut",
                        "DOWNLOAD": "Télécharger",
                        "AVAILABLE": "disponible",
                        "DISCONNECTED": "déconnecté",
                        "DELETED": "supprimé",
                        "EXPIRED": "expiré",
                        "WAITING": "en attente",
                        "FAILED": "échec",
                        "REFRESH": "Rafraîchir",
                        "NO_ARCHIVE_MESSAGE": "Il n'y a pas d'enregistrement d'appel vidéo",
                        "NAME": "Nom",
                        "STORAGE": "Espace de rangement",
                        "DURATION": "Durée",
                        "ARCHIVES": "Enregistrements d'appels vidéo",
                        "PLAY": "Jouer",
                        "DELETE": "Supprimer",
                        "DOWNLOAD_ARCHIVE": {
                            "TITLE": "Télécharger l'enregistrement",
                            "GENERATING": "Génération de l'URL de téléchargement",
                            "GENERATED": "URL de téléchargement générée",
                            "CANNOT_GENERATED": "Impossible de générer l'URL de téléchargement.",
                            "DOWNLOAD": "Télécharger",
                            "CLOSE": "Fermer"
                        },
                        "DELETE_ARCHIVE": {
                            "TITLE": "Supprimer l'enregistrement",
                            "MESSAGE": "L'enregistrement de l'appel vidéo sera supprimé.",
                            "CAUTION": "ATTENTION : Cet enregistrement sera également supprimé de votre stockage Azure.",
                            "CANCEL": "Annuler",
                            "DELETE": "Supprimer"
                        }
                    }
                },
                "CONVERTER": {
                    "TITLE": "Convertisseur",
                    "STP_ONLY": "Seuls les formats de fichiers .stp et .step sont pris en charge.",
                    "ERROR_UPLOAD": "Une erreur s'est produite lors du téléchargement du fichier.",
                    "DRAG": "Glissez & Déposez votre fichier ici",
                    "OR": "ou",
                    "CHOOSE": "Choisir le fichier",
                    "CONVERT": "Convertir",
                    "SUPPORTED": "Formats de fichiers pris en charge :",
                    "BACK": "Retour",
                    "DOWNLOAD": "Télécharger",
                    "ERROR_LOAD": "Une erreur s'est produite lors du chargement de l'objet."
                },
                "WHATSNEW": {
                    "WHATSNEW_TITLE": "Quoi de Neuf",
                    "NO_UNREAD_UPDATE": "Aucune mise à jour non lue"
                },
                "JOIN_MODAL": {
                    "JOIN" : "JOINDRE",
                    "CALL": "APPEL",
                    "CANCEL": "ANNULER",
                    "MIRROR_VIDEO": "Vidéo Miroir",
                    "PREFERRED_RESOLUTION": "Résolution préférée",
                    "RESOLUTION_NOTE": "Remarque: Si votre appareil ne prend pas en charge la résolution que vous avez demandée, la résolution la plus élevée suivante sera utilisée.",
                    "CAM_MIC_PERM_REQUIRED": "Autorisation requise pour la caméra et le microphone",
                    "CAM_MIC_PERM_DENIED": "Accès à la caméra ou au microphone refusé",
                    "CAM_MIC_CANT_ACCESS": "Nous ne pouvons pas accéder à votre caméra ou à votre microphone",
                    "JOIN_CAM_OFF": "Rejoignez l'appareil photo éteint",
                    "JOIN_MIC_OFF": "Rejoindre avec le microphone désactivé",
                    "JOIN_CAM_MIC_OFF": "Rejoignez l'appareil photo et le microphone éteints",
                    "JOIN_NO_DEVICE": "Rejoindre sans caméra ni microphone",
                    "ALLOW_ACCESS": "Vous devez autoriser l'accès à votre caméra et à votre microphone dans les paramètres de votre navigateur (après avoir accordé l'accès, vous pouvez toujours éteindre votre caméra ou votre microphone).",
                    "TRY_AGAIN": "Réessayez/actualisez la page et sélectionnez 'Autoriser' lorsque vous y êtes invité par votre navigateur."
                },
                "NO_DEVICE_MODAL": {
                    "TITLE": "Aucun appareil trouvé",
                    "JOIN_BODY": "Aucun microphone ni caméra n'est connecté à cet appareil. Les autres utilisateurs ne pourront pas vous entendre ou vous voir à travers cet appareil. Souhaitez-vous toujours adhérer ?",
                    "CALL_BODY": "Aucun microphone ni caméra n'est connecté à cet appareil. Les autres utilisateurs ne pourront pas vous entendre ou vous voir à travers cet appareil. Voulez-vous toujours appeler?",
                    "CANCEL": "Annuler",
                    "JOIN": "Rejoignez Quand Même",
                    "CALL": "Appelez Quand Même"
                },
                "AGREEMENT_MODAL": {
                    "TITLE": "Formulaire d'approbation du traitement et de la sécurité des données personnelles",
                    "REJECTION_BUTTON": "Rejeter",
                    "AGREEMENT_BUTTON": "Accepter"
                },
                "CHECK_AGREEMENT_MODAL": {
                    "TITLE": "Annuler le contrat?",
                    "ERROR": "Une erreur s'est produite.",
                    "STATEMENT": "Lorsque vous n'acceptez pas le contrat, vous ne pourrez pas vous connecter au système.",
                    "CANCEL_BUTTON": "Annuler",
                    "PROCEED_BUTTON": "Procéder"
                },
                "JOIN_UNKNOWN_ERROR" : "Une erreur est survenue en entrant dans la pièce.",
                "JOIN_CONCURRENT_ERROR" : "Vous avez atteint le nombre maximum d'utilisateurs simultanés de votre compte. Veuillez contacter votre administrateur pour plus de détails.",
                "JOIN_EXPERT_CONCURRENT_ERROR" : "Vous avez atteint le nombre maximum d'utilisateurs simultanés de votre compte. Veuillez contacter votre administrateur pour plus de détails.",
                "NO_TRAINING_LICENSE": "Il y a un problème avec votre licence de salle de formation. Veuillez contacter votre administrateur.",
                "TRAINING_LICENSE_EXPIRED": "Votre licence de salle de formation a expiré. Veuillez contacter votre administrateur.",
                "ASK_TRAINING_HOST": "Une erreur s'est produite lors de l'accès à la salle de formation. Veuillez contacter l'hôte.",
                "JOIN_CALL_IN_PROGRESS": "Il y a un autre appel dans votre salle de réunion personnelle.",
                "NOT_SUPPORTED_TITLE": "Navigateur Incompatible",
                "NOT_SUPPORTED_MESSAGE": "Votre navigateur n'est pas compatible. Veuillez utiliser Google Chrome, Mozilla Firefox, Safari ou Microsoft Edge (version 79 ou plus récente).",
                "NO_IOS_MESSAGE": "Votre navigateur n'est pas compatible. Veuillez utiliser l'application {{ appName }} Remote ou utiliser Safari.",
                "IOS_VERSION_MESSAGE": "Votre navigateur n'est pas compatible. Veuillez utiliser l'application {{ appName }} Remote.",
                "NOT_SUPPORTED_CLOSE": "Fermer",
                "IDLE_MODAL_TITLE": "Erreur",
                "IDLE_MODAL_MESSAGE": "Vous n'avez pas fait de transaction pendant longtemps.",
                "IDLE_MODAL_COUNT": "Vous serez déconnecté dans {{count}} secondes.",
                "IDLE_MODAL_OK": "Je suis revenu",
                "ARCHIVE_PERMISSION_MODAL": {
                    "TITLE": "Autoriser l'enregistrement?",
                    "MESSAGE": "La réunion dans cette salle sera enregistrée. Vous devez autoriser l'enregistrement vidéo pour rejoindre cette salle.",
                    "DENY": "Nier",
                    "ALLOW": "Autoriser"
                }
            },
            "ROOM" : {
                "OT_ERROR_MODAL": {
                    "TITLE": "Erreur",
                    "CLOSE": "Continuez Quand Même",
                    "REJOIN": "Rejoindre",
                    "ENDCALL": "Laisser",
                    "ERRORS": {
                        "INTERNET": "Impossible de connecter la session. S'il vous plait, vérifiez votre connexion internet.",
                        "TRY_AGAIN": "Une erreur s'est produite lors de la connexion de la session. Veuillez réessayer plus tard.",
                        "UNKNOWN": "Une erreur s'est produite lors de la connexion de la session.",
                        "PUBLISHER_FAILED": "Impossible de partager votre flux vidéo avec d'autres participants.",
                        "PUBLISHER_CAM_MIC_ACCESS": "Assurez-vous que votre caméra et votre microphone fonctionnent et que les autorisations de caméra/microphone sont accordées.",
                        "SUBSCRIBER_FAILED": "Impossible de se connecter à l'un des flux vidéo des participants."
                    }
                },
                "SIDEBAR" : {
                    "CHAT_TITLE" : "Bavarder",
                    "PARTICIPANTS_TITLE" : "Les participants",
                    "FILES_TITLE" : "Les fichiers",
                    "SETTINGS_TITLE" : "Réglages",
                    "SHOW_TICKET": "Billet de spectacle",
                    "ATTACH_TO_TICKET": "Joindre au billet",
                    "ATTACH_SESSION_TO_TICKET": "Attacher la session au ticket",
                    "OPEN_WORKFLOW": "Ouvrir le flux de travail",
                    "CHAT" : {
                        "SEE_TRANSLATION": "Voir la traduction",
                        "SEE_ORIGINAL": "Voir l'original",
                        "TRANSLATING": "Traduction en cours",
                        "FILE_SHARE" : {
                            "DRAG_HERE" : "Déplacez des fichiers ici",
                            "UPLOAD_TITLE": "Télécharger des fichiers",
                            "IMAGE": "Image",
                            "PDF": "Pdf",
                            "3D_OBJECT": "Objet 3D",
                            "OTHER": "Autre",
                            "MULTIPLE_OBJECTS": "Nous avons trouvé plusieurs objets dans vos fichiers. Veuillez télécharger un objet (avec des textures s'il en existe) à la fois.",
                            "LARGER_THAN": "Plus de {{ megabytes }} Mo",
                            "FILETYPE_PROHIBITED": "Type de fichier interdit",
                            "START_UPLOAD": "TÉLÉCHARGER",
                            "CANCEL_UPLOAD": "ARRÊTEZ",
                            "CLOSE_UPLOAD": "FERMER",
                            "CANCEL_MODAL_TITLE": "Arrêter les envois?",
                            "CANCEL_MODAL_MESSAGE": "Cela arrête les téléchargements en cours.",
                            "CANCEL_MODAL_CLOSE": "Annuler",
                            "CANCEL_MODAL_CANCEL": "Arrêtez"
                        },
                        "DELETE_FILE_MODAL": {
                            "TITLE": "Supprimer le fichier?",
                            "MESSAGE": "Le fichier sera supprimé.",
                            "CLOSE": "Fermer",
                            "DELETE": "Effacer"
                        },
                        "FILE_DETAILS_MODAL": {
                            "TITLE": "Détails du fichier",
                            "FILENAME": "Nom de fichier",
                            "SIZE": "Taille",
                            "TYPE": "Type",
                            "UPLOAD_TIME": "Heure de téléchargement",
                            "DOWNLOAD": "Télécharger",
                            "CLOSE": "Fermer",
                            "FILECOUNT": "Nombre total de fichiers"
                        },
                        "COLLABORATE": "Collaborer",
                        "CLOSE_COLLABORATION": "Collaboration étroite",
                        "DOWNLOAD": "Télécharger",
                        "DELETE": "Effacer",
                        "DETAILS": "Détails",
                        "SEND_TO_FILES": "Envoyer vers des fichiers",
                        "FILE_DELETED": "File deleted",
                        "JOIN_ROOM" : "{{owner_info}} a rejoint la salle.",
                        "LEAVE_ROOM" : "{{owner_info}} a quitté la pièce.",
                        "REACTION": "{{ owner_info }} a envoyé une réaction.",
                        "REQUEST_SCREENSHOT": "{{owner_info}} instantané demandé.",
                        "SHARE_SCREENSHOT" : "{{owner_info}} a partagé un instantané.",
                        "SAVED_COLLABORATION": "Collaboration enregistrée.",
                        "SHARE_IMAGE" : "{{owner_info}} a partagé une image.",
                        "SHARE_PDF" : "{{owner_info}} a partagé un pdf.",
                        "SHARE_OTHER" : "{{owner_info}} a partagé un fichier.",
                        "SHARE_OBJECT" : "{{owner_info}} a partagé un objet 3D.",
                        "COLLABORATED" : "{{owner_info}} a démarré la collaboration.",
                        "TYPE_HERE" : "écrivez ici...",
                        "PLEASE_WAIT_OTHERS": "Veuillez attendre que d'autres utilisateurs rejoignent.",
                        "DOWNLOAD_STARTED_SOON": "Le téléchargement sera bientôt commencé.",
                        "DOWNLOAD_FAILED": "Échec du téléchargement.",
                        "DOWNLOAD_OBJECT_NOT_SUPPORTED": "Le téléchargement d'objet n'est pas encore pris en charge.",
                        "DOWNLOAD_NOT_SUPPORTED": "Le téléchargement n'est pas encore pris en charge.",
                        "CLOSE_PREV_COLLABORATION_TITLE": "Fermer la collaboration de fichiers actuelle?",
                        "CLOSE_COLLABORATION_TITLE": "Fermer la collaboration de fichiers?",
                        "CLOSE_PREV_COLLABORATION_MESSAGE": "Cela fermera la collaboration de fichiers actuelle et en démarrera une nouvelle.",
                        "CLOSE_COLLABORATION_MESSAGE": "Cela fermera la collaboration de fichiers.",
                        "CLOSE_PREV_COLLABORATION_YES": "Procéder",
                        "CLOSE_PREV_COLLABORATION_NO": "Annuler",
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "Ouvrir la collaboration de fichiers?",
                            "MESSAGE_AUTHORIZED": "Une fenêtre épinglée existe. Voulez-vous le désépingler et ouvrir la collaboration de fichiers?",
                            "MESSAGE_UNAUTHORIZED": "La collaboration de fichiers ne peut pas être ouverte, car une fenêtre épinglée existe.",
                            "CANCEL": "Annuler",
                            "CLOSE": "Fermer",
                            "PROCEED": "Procéder"
                        },
                        "CLOSE_ARPLUS_BEFORE_COLL": {
                            "TITLE": "Cerrar AR+?",
                            "MESSAGE": "Debe cerrar AR+ antes de poder abrir la colaboración. ¿Seguro que quieres cerrar AR+?",
                            "NO": "No",
                            "YES": "Sí"
                        }
                    },
                    "PARTICIPANTS": {
                        "HOST": "(Directeur)",
                        "LOWER_ALL_HANDS": "Abaisser toutes les mains",
                        "RAISED_HAND": "{{ name }} leva la main.",
                        "DENIED_PUBLISH": "{{ name }} a refusé de se joindre à la communication vidéo/audio.",
                        "PARTICIPANT_LIMIT_REACHED": "Le nombre de participants aux communications vidéo/audio est atteint.",
                        "CALLING": "Appel: {{ participants }}"
                    },
                    "FILES": {
                        "INFO_TEXT": "Tous les experts et co-administrateurs qui ont accès à cette salle peuvent voir et modifier les fichiers dans cette section",
                        "DOWNLOAD": "Télécharger",
                        "SEND_TO_SESSION": "Envoyer à la session",
                        "DELETE": "Effacer",
                        "UPLOAD_FILE": "Téléverser un fichier",
                        "FILE_CONTENTS": "Contenu du fichier:",
                        "FILE_NAME": "Nom de fichier:",
                        "FILE_SIZE": "Taille du fichier:",
                        "TOTAL_SIZE": "Taille totale:",
                        "DOWNLOAD_STARTED_SOON": "Le téléchargement sera bientôt commencé.",
                        "DOWNLOAD_FAILED": "Échec du téléchargement.",
                        "DELETE_MODAL": {
                            "TITLE_DELETE": "Effacer le fichier?",
                            "MESSAGE_DELETE": "Voulez-vous vraiment supprimer ce fichier?",
                            "CANCEL": "Annuler",
                            "DELETE": "Effacer"
                        }
                    },
                    "SETTINGS": {
                        "MICROPHONE": "Microphone",
                        "CAMERA": "Caméra",
                        "TRANSLATE_OTHERS_MSG_TO": "Traduire les Autres Messages en:",
                        "TRANSLATE_MY_MSG_TO": "Traduire mes Messages en:",
                        "CREATE_GUEST_ACCESS": "Créer un accès invité",
                        "GENERATING": "Générateur",
                        "GUEST_ACCESS": "Accès invité",
                        "COPY_LINK": "Copie",
                        "LINK_COPIED": "Lien copié dans le presse-papiers.",
                        "LINK_GENERATED": "Lien vers la session de réunion généré.",
                        "CANNOT_CREATE_GUEST_ACCESS": "Impossible de créer un accès invité.",
                        "NO_LINK_PERMISSION": "Vous n'êtes pas autorisé à créer un lien d'accès invité. Veuillez contacter votre administrateur.",
                        "SHARE": "Partager",
                        "SHARE_LINK_VIA_SMS": "Partager le lien par SMS",
                        "SMS_SEND": "Lien envoyé par SMS",
                        "OPENING": "Ouverture",
                        "SEND": "Envoyer",
                        "SMS_LIMIT_REACHED": "Limite d'envoi de SMS atteinte. Veuillez contacter votre administrateur.",
                        "ERROR_OCCURED": "Une erreur s'est produite.",
                        "SMS_LICENSE_PERMISSION": "Vous n'êtes pas autorisé à envoyer des SMS. Veuillez contacter votre administrateur.",
                        "RESHARE": "Vous pouvez partager le lien une fois par minute.",
                        "DIDNT_GET": "Vous n'avez pas reçu le lien?",
                        "PHONE_NUMBERS": "Numéros de téléphone récemment utilisés",
                        "RESEND": "Renvoyer.",
                        "CANCEL": "Annuler",
                        "CONNECT_VIA_FIELD_CODE": "Connectez-vous avec l'utilisateur via Field ID",
                        "CONNECT": "Relier",
                        "INVITATION_SENT": "L'invitation a été envoyée à l'utilisateur.",
                        "INVITATION_COULD_NOT_SENT": "L'invitation n'a pas pu être envoyée à l'utilisateur.",
                        "FIELD_CODE": "Field ID"
                    }
                },
                "VIDEO_CHAT" : {
                    "AUDIO_BITRATE": "Bitrate audio",
                    "AUDIO_PACKET_LOSS": "Perte de paquets audio",
                    "VIDEO_BITRATE": "Bitrate vidéo",
                    "VIDEO_PACKET_LOSS": "Perte de paquets vidéo",
                    "RESOLUTION": "Résolution",
                    "WAIT_OTHER_USERS" : "Veuillez attendre que d'autres utilisateurs rejoignent.",
                    "WAIT_EXPERT": "Veuillez attendre que l'expert se joigne.",
                    "WAIT_MASTER": "Veuillez attendre que Directeur démarre la session.",
                    "START_SESSION": "DÉBUT DE SESSION",
                    "HOST_WITHDRAW_REQUEST": "Directeur retire la demande vidéo/audio.",
                    "NO_CAM_MIC": "Votre caméra et votre microphone ne sont pas disponibles.",
                    "NO_CAM": "Votre caméra n'est pas disponible.",
                    "NO_MIC": "Votre microphone n'est pas disponible.",
                    "JOIN_VIDEO_AUDIO_MODAL": {
                        "TITLE": "Rejoindre la communication vidéo/audio?",
                        "MESSAGE": "Directeur aimeraient que vous activiez votre vidéo / audio.",
                        "DENY": "Nier",
                        "ACCEPT": "J'accepte"
                    },
                    "PUBLISHER" : {
                        "YOU": "Vous",
                        "SCREEN_SHARE_MESSAGE": "Vous partagez votre écran",
                        "STOP_SCREEN_SHARING": "Arrêtez le partage"
                    },
                    "SUBSCRIBER" : {
                        "APP_NOT_UP_TO_DATE_FOR_STATS": "L'état du réseau ne peut pas être affiché car l'application de ce participant n'est pas à jour.",
                        "SNAPSHOT": "Instantané",
                        "AR_PLUS": "AR Collaboration",
                        "SCREENSHOT_REQUESTED": "Instantané demandé.",
                        "VIDEO_NOT_AVAILABLE": "La vidéo n'est pas disponible.",
                        "WEAK_SIGNAL": "Signal faible",
                        "AUDIO_ONLY_MODE": "Mode audio uniquement",
                        "FLASH": "Flash",
                        "AR_NOT_AVAILABLE": "AR non disponible pour cet appareil.",
                        "CHARGING": "Mise en charge",
                        "LOW_BATTERY": "Batterie faible",
                        "CLOSE_AR_PLUS_MODAL": {
                            "TITLE": "Fermer AR+?",
                            "MESSAGE": "Voulez-vous vraiment fermer AR+?",
                            "NO": "Non",
                            "YES": "Oui"
                        },
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "Ouvrir AR+?",
                            "MESSAGE_AUTHORIZED": "Une fenêtre épinglée existe. Voulez-vous le détacher et ouvrir AR+?",
                            "MESSAGE_UNAUTHORIZED": "L'AR+ ne peut pas s'ouvrir, car une fenêtre épinglée existe.",
                            "CANCEL": "Annuler",
                            "CLOSE": "Fermer",
                            "PROCEED": "Procéder"
                        },
                        "REFRESH_SURFACES": "Rafraîchir les surfaces",
                        "AR_PLUS_LOCKED": "AR+ est verrouillé. Veuillez d'abord déverrouiller AR+."
                    },
                    "CONTROL_BAR": {
                        "SHARE_SCREEN": "Partager l'écran",
                        "STOP_SHARE": "Arrêtez le partage",
                        "MIC_OFF": "Microphone",
                        "CAM_OFF": "Caméra",
                        "CAM_MIC_CANT_ACCESS": "Nous ne pouvons pas accéder à votre caméra ou à votre microphone",
                        "LEAVE_CALL": "Laisser",
                        "LEAVE_SESSION": "Quitter la session",
                        "LEAVE_MEETING": "Quitter la réunion",
                        "END_SESSION_FOR_ALL": "Fin de session pour tous",
                        "END_MEETING_FOR_ALL": "Mettre fin à la réunion pour tous",
                        "ENDCALL_MODAL": {
                            "TITLE_LEAVE": "Quitter la session?",
                            "TITLE_LEAVE_MEETING": "Quitter la réunion ?",
                            "TITLE_END_ALL": "Fin de session pour tous?",
                            "TITLE_END_ALL_MEETING": "Mettre fin à la réunion pour tous?",
                            "MESSAGE_LEAVE": "Êtes-vous sûr de vouloir quitter la session?",
                            "MESSAGE_END_ALL": "Êtes-vous sûr de vouloir mettre fin à la session ?",
                            "MESSAGE_LEAVE_MEETING": "Êtes-vous sûr de vouloir quitter la réunion ?",
                            "MESSAGE_END_ALL_MEETING": "Êtes-vous sûr de vouloir mettre fin à la réunion ?",
                            "CANCEL": "Annuler",
                            "END": "Fin",
                            "LEAVE": "Quitter",
                            "REMOVE_MEETING_LINK": "Désactivez et supprimez également le lien de réunion"
                        },
                        "RAISE_HAND": "Lever la main",
                        "LOWER_HAND": "Main inférieure",
                        "RECORD": "Enregistrement",
                        "AUTO_RECORD": "Auto Enregistrement",
                        "STOP_RECORD": "Arrêter l'enregistrement",
                        "CANCEL": "Demande d'annulation",
                        "ASK_ARCHIVE_PERMISSION": "Demander l'autorisation d'enregistrement",
                        "REACTION": "Réaction",
                        "EXTENSION_MODAL_TITLE": "Extension requise",
                        "EXTENSION_MODAL_MESSAGE": "Google Chrome nécessite une extension pour la fonctionnalité de partage d'écran. Veuillez installer une extension ou utiliser Mozilla Firefox.",
                        "EXTENSION_MODAL_NO": "Annuler",
                        "EXTENSION_MODAL_YES": "Ouvrir la page d'extension",
                        "ARCHIVE_NO_PERMISSION": "Vous n'êtes pas autorisé à enregistrer cette session. Veuillez contacter votre administrateur.",
                        "P2P_NO_ARCHIVE": "Enregistrement non disponible pour les appels vidéo poste à poste. Veuillez contacter votre administrateur.",
                        "SCREEN_SHARE_UPDATE": "La version actuelle de votre navigateur ne prend pas en charge le partage d'écran. Veuillez mettre à jour votre navigateur s'il vous plait.",
                        "SCREEN_SHARE_NOT_SUPPORTED": "Votre navigateur ne supporte pas le partage d'écran.",
                        "SCREEN_SHARE_USE_OTHER": "Votre navigateur ne supporte pas le partage d'écran. Veuillez utiliser Google Chrome ou Mozilla Firefox.",
                        "SCREEN_SHARE_FAILED": "Impossible de partager l'écran.",
                        "ARCHIVE_REQUESTED": "L'enregistrement vidéo démarre. Votre permission est requise.",
                        "ARCHIVE_REQUESTED_WITH_NAME": "{{ name }} veut commencer l'enregistrement vidéo. Votre permission est requise.",
                        "DENY": "Nier",
                        "ALLOW": "Autoriser"
                    },
                    "PDF_COLLABORATION": {
                        "PREVIOUS_PAGE": "Page Précédente",
                        "NEXT_PAGE": "Page Suivante"
                    },
                    "COLLABORATION_SHARED": {
                        "SOME_USERS_CANNOT_LOAD": "Certains utilisateurs ne peuvent pas charger la collaboration de fichiers.",
                        "DOWNLOAD_FAILED": "Impossible de télécharger la collaboration de fichiers.",
                        "END_COLL_TITLE": "Fermer la collaboration de fichiers?",
                        "END_COLL_MESSAGE": "Cela fermera la collaboration de fichiers.",
                        "END_COLL_NO": "Annuler",
                        "END_COLL_YES": "Procéder",
                        "ALREADY_ENDED": "La collaboration de fichiers est déjà terminée.",
                        "CANNOT_END_COLLABORATION": "Impossible de mettre fin à la collaboration de fichiers.",
                        "ANNOTATE": "Annoter",
                        "FULLSCREEN": "Plein écran",
                        "DOWNLOAD_COLLABORATION": "Télécharger la collaboration",
                        "SNAPSHOT_COLLABORATION": "Instantané",
                        "UNDO": "Annuler",
                        "REDO": "Refaire",
                        "REVERT": "Revenir",
                        "RELOAD": "Recharger"
                    },
                    "TRY_TO_FOCUS_MODAL": {
                        "TITLE": "Épingler la fenêtre?",
                        "MESSAGE": "L'épinglage en mode AR+ n'est pas possible. Fermer AR+ et épingler?",
                        "CANCEL": "Annuler",
                        "PROCEED": "Procéder"
                    }
                }
            },
            "RECONNECT_ROOM": {
                "RECONNECT_MESSAGE": "On dirait qu'une erreur est survenue. Nous tentons de vous reconnecter à l'appel."
            },
            "SESSION_RATING": {
                "BAD": "Mauvais",
                "POOR": "Inadéquat",
                "FAIR": "Moyenne",
                "GOOD": "Bon",
                "EXCELLENT": "Excellent",
                "RATING_MESSAGE" : "Quelle était la qualité de la session ?",
                "REVIEW_MESSAGE" : "Dites-nous pourquoi (facultatif)",
                "SUCCESS_MESSAGE": "Merci d'avoir noté la session.",
                "CLOSE": "Fermer",
                "SUBMIT": "Soumettre",
                "DISMISS": "Rejeter"
            },
            "PRECALL_TEST": {
                "BACK_TO_LOBBY": "Retour au Lobby",
                "RUN_PRECALL_TEST": "Exécutez le test Precall",
                "WHAT_TEST": {
                    "TITLE": "Nous allons tester",
                    "CONNECTIVITY": "Connectivité à tous les serveurs multimédias.",
                    "STATS": "Collectez les statistiques de débit binaire et de perte de paquets.",
                    "SETUP": "Configuration matérielle et logicielle sur le point final (caméra, microphone, navigateur)."
                },
                "BEFORE_START": {
                    "TITLE": "Avant de commencer",
                    "MAKE_SURE": "Assure-toi;",
                    "RIGHT_NETWORK": "Vous êtes sur le réseau spécifique que vous souhaitez tester.",
                    "TCP_PORT_OPEN": "Vous avez au moins le port TCP 443 ouvert.",
                    "RIGHT_HARDWARE": "La bonne caméra et le bon micro sont sélectionnés.",
                    "BANDWITH": "La bande passante est supérieure à 350 kbps de téléchargement et de téléchargement."
                },
                "HARDWARE_SOFTWARE": {
                    "TITLE": "Configuration Matérielle/Logicielle",
                    "OPERATING_SYSTEM": {
                        "MESSAGE": "Système opérateur",
                        "BETTER_ALTERNATIVE_IOS": "Vous pouvez télécharger {{ appName }} Remote App depuis AppStore pour une meilleure expérience.",
                        "BETTER_ALTERNATIVE_ANDROID": "Vous pouvez télécharger {{ appName }} Remote App depuis Google Play Store pour une meilleure expérience."
                    },
                    "BROWSER": {
                        "MESSAGE": "Navigateur",
                        "NOT_SUPPORTED": "Ton navigateur n'est pas supporté. Veuillez utiliser Google Chrome, Mozilla Firefox, Safari ou Microsoft Edge (version 79 ou plus récente).",
                        "NOT_COMPATIBLE": "Votre navigateur n'est pas compatible. Veuillez mettre à jour votre navigateur s'il vous plait.",
                        "USE_SAFARI": "Votre navigateur n'est pas compatible. Veuillez utiliser l'application {{ appName }} Remote ou utiliser Safari."
                    },
                    "HARDWARE": {
                        "MESSAGE": "Accès Caméra/Microphone",
                        "CANT_ACCESS": "Nous ne pouvons pas accéder à votre caméra/microphone."
                    }
                },
                "CONNECTION_SERVERS": {
                    "TITLE": "Connexion à Nos Serveurs",
                    "INTERNET": {
                        "MESSAGE": "Connexion Internet",
                        "OFFLINE": "Votre connexion Internet semble être hors ligne."
                    },
                    "SERVERS": {
                        "MESSAGE": "Connexion à nos serveurs",
                        "UNKNOWN_ERROR_TRY": "Une erreur s'est produite lors de la connexion aux serveurs. Veuillez réessayer plus tard.",
                        "UNKNOWN_ERROR": "Une erreur s'est produite lors de la connexion aux serveurs."
                    }
                },
                "QUALITY": {
                    "TITLE": "Qualité Audio/Vidéo",
                    "AUDIO_VIDEO": {
                        "MESSAGE": "Qualité Audio/Vidéo",
                        "UNKNOWN_ERROR": "Une erreur s'est produite lors du test de la qualité audio/vidéo.",
                        "VIDEO": "Vidéo",
                        "VIDEO_QUALITY": "Qualité Vidéo: ",
                        "VIDEO_PACKET_LOSS": "Perte de paquets:",
                        "VIDEO_BITRATE": "Bitrate Vidéo: ",
                        "AUDIO": "Audio",
                        "AUDIO_QUALITY": "Qualité Audio: ",
                        "AUDIO_PACKET_LOSS": "Perte de paquets:",
                        "AUDIO_BITRATE": "Bitrate Audio: ",
                        "QUALITY_EXCELLENT": "(Excellent)",
                        "QUALITY_GOOD": "(Bien)",
                        "QUALITY_BAD": "(Mal)"
                    }
                },
                "STOP_TEST_MODAL": {
                    "TITLE": "Arrêter le test?",
                    "MESSAGE": "Cela arrêtera le test Precall.",
                    "NO": "Annuler",
                    "YES": "Arrêtez"
                }
            },
            "EMAIL_RECIPIENTS": {
                "PLACEHOLDER": "Ajouter nouveau",
                "SECONDARY_PLACEHOLDER": "Entrer l'adresse e-mail",
                "INVALID_EMAIL": "Format d'email invalide."
            },
            "WORKFLOW_REMOTE": {
                "ERRORS": {
                    "INTEGRATION_ALREADY_USED": "Intégration déjà utilisée",
                    "MISSING_PARAMETERS": "Il manque des paramètres",
                    "CALL_IN_PROGRESS": "L'appel est en cours",
                    "USER_IN_ANOTHER_ROOM": "Utilisateur dans une autre pièce"
                }
            }
        },
        "HELP_CENTER": {
            "TITLE": "{{ appName }} Centre d'aide",
            "TITLE_WITH_REMOTE": "{{ appName }} Remote Centre d'aide",
            "FAILED": "Une erreur s'est produite."
        },
        "EXTERNALS": {
            "JOIN_WITH_LINK": {
                "TITLE": "{{ appName }} Accès invité à distance",
                "SESSION_NOT_FOUND": "La session que vous avez demandée est introuvable.",
                "SESSION_NOT_AVAILABLE": "Cette session n'est plus disponible.",
                "CONCURRENT_LIMIT_REACHED": "Limite d'utilisateurs simultanés atteinte. Veuillez contacter votre administrateur.",
                "EXPERT_CONCURRENT_LIMIT_REACHED": "Limite d'utilisateurs simultanés atteinte. Veuillez contacter votre administrateur.",
                "UNKNOWN_ERROR": "Quelque chose a mal tourné.",
                "ABOUT_TO_JOIN": "Vous êtes sur le point de rejoindre ",
                "ENTER_NAME": "Entrez votre nom",
                "NAME_REQUIRED": "Nom obligatoire",
                "NAME_SHORT": "Le nom doit contenir au moins 2 caractères",
                "JOIN": "JOINDRE",
                "CONTINUE_TO_WEBSITE": "Continuer via le Navigateur"
            },
            "ARCHIVE_LIST": {
                "TITLE": "Enregistrements d'appels vidéo",
                "LOADING": "Chargement",
                "LOAD_FAILED": "Une erreur s'est produite.",
                "CREATED_AT": "Créé à",
                "SIZE": "Taille",
                "STATUS": "Statut",
                "DOWNLOAD": "Télécharger",
                "GENERATING": "Génération du lien",
                "CLICK_TO_DOWNLOAD": "Cliquez pour télécharger",
                "AVAILABLE": "disponible",
                "DISCONNECTED": "déconnecté",
                "DELETED": "supprimé",
                "EXPIRED": "expiré",
                "WAITING": "en attente",
                "FAILED": "échec"
            },
            "AUTHENTICATE": {
                "MESSAGE": "Une erreur s'est produite."
            },
            "AD_LOGIN": {
                "MESSAGE": "Une erreur s'est produite."
            },
            "AD_ERROR": {
                "ACCOUNT_NOT_FOUND": "Votre compte n'est pas connecté à Azure AD.",
                "PERMISSION_DENIED": "Vous n'êtes pas autorisé à voir cette page.",
                "INTERNAL_ERROR": "Une erreur s'est produite.",
                "CONTACT_MAIL": "Veuillez contacter <strong>{{ contactMail }}</strong>"
            }
        },
        "TUTORIALS": {
            "TUTORIAL_LINK": "Montre le guide d'utilisation",
            "NEXT": "Prochain",
            "END": "Fin",
            "MIC_CAMERA": "Ouvrir/Fermer le microphone ou la caméra",
            "END_CALL": "Quitter la session",
            "RECORD": "Démarrer/Arrêter l'enregistrement pour toutes les sessions",
            "SCREEN_SHARING": "Démarrer/Arrêter le partage d'écran pour montrer ce que vous faites aux autres utilisateurs",
            "REACTION": "Envoyer une réaction à tout le monde, utile lorsque la communication vocale n'est pas suffisante",
            "OPEN_AR_PLUS": "Ouvrir AR+",
            "DRAW_ON_SURFACE": "Dessinez sur des surfaces surlignées d'une grille bleue en direct avec AR+",
            "OPEN_AR": "Ouvrir AR",
            "HOLD_TO_HIGHLIGHT": "Cliquez et maintenez n'importe où pour mettre en évidence une zone spécifique sur le flux en direct avec AR",
            "TAKE_SNAPSHOT": "Prenez un instantané de haute qualité d'un autre utilisateur",
            "NO_CAMERA": "La caméra de l'autre participant doit être allumée",
            "WAIT_OR_SKIP": "Attendez un autre utilisateur ou ignorez cette fonctionnalité",
            "COLLABORATE": "Collaborez sur des instantanés: esquissez, mettez des diagrammes, des formes spéciales, des textes",
            "OPEN_ANNOTATION": "Annotation ouverte",
            "SKETCH_ON_COLL": "Esquisse sur le volet de collaboration",
            "END_TUTORIAL": "Vous pouvez accéder à ce tutoriel à tout moment à partir d'ici",
            "USER_TUTORIAL": "Tutoriel utilisateur",
            "GUIDE": "Ce tutoriel utilisateur vous guidera pas à pas à travers la plateforme",
            "DONT_SHOW": "Ne plus afficher",
            "SKIP_TUTORIAL": "Ignorer le didacticiel",
            "CANCEL": "Annuler",
            "SKIP": "Sauter",
            "ASK_AGAIN": "Voulez-vous vraiment ignorer ce didacticiel ?"
        },
        "NOT_FOUND": {
            "PAGE_NOT_FOUND": "Nous sommes désolés, la page que vous avez demandée est introuvable.",
            "NO_LONGER_AVAILABLE": "L'URL peut être mal orthographiée ou la page que vous recherchez n'est plus disponible."
        },
        "DOWNLOADS": {
            "FILE_NOT_FOUND": "Fichier introuvable",
            "IF_DOWNLOAD_NOT_STARTED": "Si le téléchargement n'a pas commencé, ",
            "CLICK_HERE": "cliquez ici"
        },
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Éléments par page :",
        "NEXT_PAGE": "Page suivante",
        "PREVIOUS_PAGE": "Page précédente",
        "FIRST_PAGE": "Première page",
        "LAST_PAGE": "Dernière page",
        "RANGE": "{{start}} – {{end}} sur {{length}}",
        "RANGE_ZERO": "0 sur {{length}}"
    }
}